"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_SEGMENT_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var DisplayShelfFragment_1 = require("./DisplayShelfFragment");
exports.DISPLAY_SEGMENT_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment DisplaySegment on DisplaySegment {\n    id\n    name\n    segmentNumber\n    shelves {\n      ...DisplayShelf\n    }\n    height\n    width\n    depth\n    xOffset\n  }\n  ", "\n"], ["\n  fragment DisplaySegment on DisplaySegment {\n    id\n    name\n    segmentNumber\n    shelves {\n      ...DisplayShelf\n    }\n    height\n    width\n    depth\n    xOffset\n  }\n  ", "\n"])), DisplayShelfFragment_1.DISPLAY_SHELF_FRAGMENT);
var templateObject_1;
